export default "__VITE_ASSET__8nDa$Std__"